import SiteManager from "components/siteManager/SiteManager";
import React from "react";

export default () => {
  return <SiteManager />;
};
